import { defineComponent as _defineComponent } from 'vue'
import BCXMobileFullscreenDesktopLayer from '@/components/molecules/BCXMobileFullscreenDesktopLayer.vue';
import SidebarAsMobileLayer from '@/views/project-forum/components/sidebar-actions/SidebarAsMobileLayer.vue';
import { InfoBoxType } from '@/models/InfoBox';
import { PropType } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BCXSidebarAsLayer',
  props: {
  isLayerOpen: Boolean,
  title: {
    type: String, default: ''
  },
  type: {
    type: String as PropType<InfoBoxType>,
    default: InfoBoxType.INFOBOX_STANDARD
  }
},
  setup(__props) {





return { __sfc: true,BCXMobileFullscreenDesktopLayer, SidebarAsMobileLayer, InfoBoxType }
}

})